import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import enhanceWithClickOutside from 'react-click-outside'

import {
  CONTACT_US_MODAL,
  PARTNER_SELECTOR_MODAL,
  SUPERUSER_SELECTOR_MODAL,
} from 'constants/modal-constants'

import { getIdentityPortalUser, getIdentityPortalSuperuser } from 'selectors/settings'
import { isNavigationDropdownOpen } from 'selectors/navigation'
import { getPathname } from 'selectors/common'
import { showModal } from 'actions/common'
import { navigationDropdownToggle } from 'actions/navigation'
import { getPartnerUrl } from 'utils/urls'
import SubNavigation from './sub-navigation'
import { URLS } from '../../constants/url-constants'

export class SubNavigationContainer extends Component {

  constructor(props) {
    super(props)

    this.handleModalClick = this.handleModalClick.bind(this)
    this.handleUserClick = this.handleUserClick.bind(this)
  }

  handleClickOutside() {
    if (this.props.isDropdownOpen) {
      this.props.navigationDropdownToggle()
    }
  }

  handleModalClick(modal) {
    this.props.showModal(modal)
  }

  handleUserClick() {
    this.props.navigationDropdownToggle()
  }

  render() {
    const { partner, isDropdownOpen, pathname } = this.props
    const homeLink = partner ? getPartnerUrl(partner.id) : '/'
    let items = []

    if (this.props.isSuperuser) {
      items = [...items, {
        label: 'Sudo another user',
        modal: SUPERUSER_SELECTOR_MODAL,
        staffOnly: true,
      }]
    }

    if (this.props.isStaffUser) {
      items = [...items, {
        label: 'Search all partners',
        modal: PARTNER_SELECTOR_MODAL,
        staffOnly: true,
      }]
    }

    if (partner) {
      items = [...items,
        {
          label: 'Switch account',
          path: '/',
          external: true,
        },
        {
          label: 'Settings',
          path: `${homeLink}/settings`,
        },
      ]
    }

    items = [...items,
      {
        label: 'Contact Us',
        modal: CONTACT_US_MODAL,
      },
      {
        label: 'Terms and Conditions',
        external: true,
        path: URLS.shopTerms
      },
    ]

    if (partner) {
      items = [...items,
        {
          label: 'Logout',
          path: '/logout',
          external: true,
        },
      ]
    } else {
      items = [...items,
        {
          label: 'Login',
          path: `/login?next=${pathname}`,
          external: true,
        },
      ]
    }

    return (
      <SubNavigation
        dropdownOpen={isDropdownOpen}
        homeLink={homeLink}
        items={items}
        loggedIn={!!partner}
        onModalClick={this.handleModalClick}
        onUserClick={this.handleUserClick}
      />
    )
  }
}

SubNavigationContainer.propTypes = {
  isSuperuser: PropTypes.bool,
  isStaffUser: PropTypes.bool,
  isDropdownOpen: PropTypes.bool,
  navigationDropdownToggle: PropTypes.func,
  partner: PropTypes.object,
  pathname: PropTypes.string,
  showModal: PropTypes.func,
}


const mapStateToProps = (state) => {
  const portalUser = getIdentityPortalUser(state)

  return {
    isStaffUser: portalUser && portalUser.isStaffUser,
    isSuperuser: getIdentityPortalSuperuser(state) !== null,
    isDropdownOpen: isNavigationDropdownOpen(state),
    pathname: getPathname(state),
  }
}

const mapDispatchToProps = { showModal, navigationDropdownToggle }

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(SubNavigationContainer))



/** WEBPACK FOOTER **
 ** ./src/components/sub-navigation/sub-navigation-container.js
 **/